const onInvoicePageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector(
      '.PageContent.form-content-with-pdf'
    )

    if (pageContent) {
      clearInterval(waitForPageLoad)
      caseComboBox()
      reserveWithdrawalButton()
      runDuplicateInvoiceAlertOnEditLoad()
      // setupDuplicateInvoiceCheck()
      
      const existingNotesSection = document.querySelector('#notesAndApproval')
      if (existingNotesSection) {
        return
      }
      taskListforInvoice()

      console.log('onInvoicePageMatch')
      const currentInvoiceId = (window.location.pathname.split('/').pop() || '').trim()
      const getResolvedDomainFromToken = () => {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
        return resolveDomain(decodedToken.domainId || 1)
      }

      if (window.invoiceSectionContextInvoiceId !== currentInvoiceId) {
        window.invoiceSectionContextInvoiceId = currentInvoiceId
        window.invoiceSectionPropertyId = null
        window.invoiceSectionPropertyContext = {
          invoiceId: currentInvoiceId,
          propertyId: null,
          propertyHrId: null
        }
      }

      // Initialize global fetch tracking for skeleton loading
      window.invoiceSectionFetchState = {
        notesAndApprovalFetched: false,
        tasksFetched: false,
        checkComplete: function() {
          if (this.notesAndApprovalFetched && this.tasksFetched) {
            // Hide skeleton and show real content
            const skeleton = document.getElementById('invoice-section-skeleton')
            const realContent = document.getElementById('invoice-section-real-content')
            if (skeleton) {
              skeleton.style.display = 'none'
            }
            if (realContent) {
              realContent.style.display = 'block'
            }
          }
        },
        markNotesAndApprovalFetched: function() {
          this.notesAndApprovalFetched = true
          this.checkComplete()
        },
        markTasksFetched: function() {
          this.tasksFetched = true
          this.checkComplete()
        }
      }

      // Create skeleton loader
      function createSkeletonLoader() {
        const skeleton = document.createElement('div')
        skeleton.id = 'invoice-section-skeleton'
        skeleton.style.cssText = `
          padding: 0;
        `

        // Add pulse animation style
        const style = document.createElement('style')
        style.id = 'skeleton-pulse-style'
        style.textContent = `
          @keyframes skeletonPulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          .skeleton-pulse {
            animation: skeletonPulse 1.5s ease-in-out infinite;
          }
        `
        if (!document.getElementById('skeleton-pulse-style')) {
          document.head.appendChild(style)
        }

        // Approval skeleton (3 cards: Freigabe, Manager, Externe Freigabe)
        const approvalSkeleton = document.createElement('div')
        approvalSkeleton.style.cssText = `
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-top: 16px;
          margin-bottom: 12px;
        `
        for (let i = 0; i < 3; i++) {
          const approvalCard = document.createElement('div')
          approvalCard.className = 'skeleton-pulse'
          approvalCard.style.cssText = `
            height: 42px;
            background-color: #f0f0f0;
            border-radius: 4px;
          `
          approvalSkeleton.appendChild(approvalCard)
        }

        // Notes header skeleton
        const notesHeaderSkeleton = document.createElement('div')
        notesHeaderSkeleton.style.cssText = `
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          margin-top: 12px;
        `
        const notesTitleSkeleton = document.createElement('div')
        notesTitleSkeleton.className = 'skeleton-pulse'
        notesTitleSkeleton.style.cssText = `
          width: 80px;
          height: 20px;
          background-color: #f0f0f0;
          border-radius: 4px;
        `
        const notesButtonSkeleton = document.createElement('div')
        notesButtonSkeleton.className = 'skeleton-pulse'
        notesButtonSkeleton.style.cssText = `
          width: 40px;
          height: 32px;
          background-color: #f0f0f0;
          border-radius: 4px;
        `
        notesHeaderSkeleton.appendChild(notesTitleSkeleton)
        notesHeaderSkeleton.appendChild(notesButtonSkeleton)

        // Notes cards skeleton (2 cards)
        const notesCardsSkeleton = document.createElement('div')
        notesCardsSkeleton.style.cssText = `
          display: flex;
          flex-direction: column;
          gap: 4px;
        `
        for (let i = 0; i < 2; i++) {
          const noteCard = document.createElement('div')
          noteCard.className = 'skeleton-pulse'
          noteCard.style.cssText = `
            height: 72px;
            background-color: #f0f0f0;
            border-radius: 4px;
          `
          notesCardsSkeleton.appendChild(noteCard)
        }

        // Tasks section skeleton
        const tasksSkeleton = document.createElement('div')
        tasksSkeleton.style.cssText = `
          margin-top: 12px;
          padding-top: 16px;
          border-top: 1px solid #eee;
        `
        const tasksHeaderSkeleton = document.createElement('div')
        tasksHeaderSkeleton.style.cssText = `
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        `
        const tasksTitleSkeleton = document.createElement('div')
        tasksTitleSkeleton.className = 'skeleton-pulse'
        tasksTitleSkeleton.style.cssText = `
          width: 80px;
          height: 20px;
          background-color: #f0f0f0;
          border-radius: 4px;
        `
        const tasksButtonSkeleton = document.createElement('div')
        tasksButtonSkeleton.className = 'skeleton-pulse'
        tasksButtonSkeleton.style.cssText = `
          width: 40px;
          height: 32px;
          background-color: #f0f0f0;
          border-radius: 4px;
        `
        tasksHeaderSkeleton.appendChild(tasksTitleSkeleton)
        tasksHeaderSkeleton.appendChild(tasksButtonSkeleton)

        // Task items skeleton (2 items)
        const taskItemsSkeleton = document.createElement('div')
        taskItemsSkeleton.style.cssText = `
          display: flex;
          flex-direction: column;
          gap: 8px;
        `
        for (let i = 0; i < 2; i++) {
          const taskItem = document.createElement('div')
          taskItem.className = 'skeleton-pulse'
          taskItem.style.cssText = `
            height: 42px;
            background-color: #f0f0f0;
            border-radius: 4px;
          `
          taskItemsSkeleton.appendChild(taskItem)
        }

        tasksSkeleton.appendChild(tasksHeaderSkeleton)
        tasksSkeleton.appendChild(taskItemsSkeleton)

        // Assemble skeleton
        skeleton.appendChild(approvalSkeleton)
        skeleton.appendChild(notesHeaderSkeleton)
        skeleton.appendChild(notesCardsSkeleton)
        skeleton.appendChild(tasksSkeleton)

        return skeleton
      }
      
      // FormSection wrapper (outer)
      var notesSection = document.createElement('div')
      notesSection.className = 'FormSection'
      notesSection.id = 'notesAndApproval'

      // form-section-wrapper
      var formSectionWrapper = document.createElement('div')
      formSectionWrapper.className = 'form-section-wrapper open'

      // main-section-header
      var headerContainer = document.createElement('div')
      headerContainer.className = 'main-section-header section-header open'
      headerContainer.style.cursor = 'pointer'

      // section-number-box
      var sectionNumberBox = document.createElement('div')
      sectionNumberBox.className = 'section-number-box open'

      var sectionNumber = document.createElement('div')
      sectionNumber.className = 'section-number'
      sectionNumber.textContent = '0'

      sectionNumberBox.appendChild(sectionNumber)

      // section-title-box
      var sectionTitleBox = document.createElement('div')
      sectionTitleBox.className = 'section-title-box open'
      sectionTitleBox.style.flex = '1'

      var sectionTitle = document.createElement('div')
      sectionTitle.className = 'section-title'
      sectionTitle.style.display = 'flex'
      sectionTitle.style.alignItems = 'center'
      sectionTitle.style.justifyContent = 'space-between'
      sectionTitle.style.width = '100%'
      
      var sectionTitleText = document.createElement('span')
      sectionTitleText.textContent = 'Allgemeines'
      sectionTitle.appendChild(sectionTitleText)

      // Badges container: stack multiple badges vertically so they fit in the header
      var headerBadgesContainer = document.createElement('div')
      headerBadgesContainer.id = 'section-header-badges'
      headerBadgesContainer.style.cssText = `
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        flex-shrink: 0;
      `
      sectionTitle.appendChild(headerBadgesContainer)

      // Tax exemption badge container (will be populated after API call)
      var taxExemptionBadge = document.createElement('span')
      taxExemptionBadge.id = 'tax-exemption-badge'
      taxExemptionBadge.style.cssText = `
        display: none;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
      `
      headerBadgesContainer.appendChild(taxExemptionBadge)

      var aiNoteIndicatorUI = aiNoteIndicatorForInvoice(headerBadgesContainer)

      sectionTitleBox.appendChild(sectionTitle)
      
      // Function to update tax exemption badge
      function updateTaxExemptionBadge(taxExemptionStatus) {
        if (!taxExemptionStatus || !taxExemptionStatus.exists) {
          taxExemptionBadge.style.display = 'none'
          return
        }
        
        taxExemptionBadge.style.display = 'inline-block'
        
        if (!taxExemptionStatus.isValid) {
          // Red badge - not valid
          taxExemptionBadge.textContent = 'Freistellungsbescheinigung ungültig'
          taxExemptionBadge.style.backgroundColor = '#fee2e2'
          taxExemptionBadge.style.color = '#dc2626'
        } else if (taxExemptionStatus.isExpiringSoon) {
          // Orange badge - expiring soon (within 3 months)
          taxExemptionBadge.textContent = 'Freistellungsbescheinigung läuft bald ab'
          taxExemptionBadge.style.backgroundColor = '#ffedd5'
          taxExemptionBadge.style.color = '#ea580c'
        } else {
          // Green badge - valid
          taxExemptionBadge.textContent = 'Freistellungsbescheinigung gültig'
          taxExemptionBadge.style.backgroundColor = '#dcfce7'
          taxExemptionBadge.style.color = '#16a34a'
        }
      }
      
      // Function to fetch tax exemption status from separate endpoint
      async function fetchTaxExemptionStatus(contactId) {
        if (!contactId) return
        try {
          const response = await fetch(`${baseApiUrl}/api/impowerX/contacts/tax-exemption/contact/${contactId}/status`, {
            headers: {
              'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
              'Content-Type': 'application/json'
            }
          })
          if (response.ok) {
            const data = await response.json()
            if (data.taxExemptionStatus) {
              updateTaxExemptionBadge(data.taxExemptionStatus)
            }
          }
        } catch (e) {
          console.error('Error fetching tax exemption status:', e)
        }
      }

      headerContainer.appendChild(sectionNumberBox)
      headerContainer.appendChild(sectionTitleBox)

      // section-content (collapsible)
      var contentContainer = document.createElement('div')
      contentContainer.className = 'section-content'
      contentContainer.style.padding = '0 24px 24px 64px'
      var isContentVisible = true // Start open

      function updateSectionState() {
        if (isContentVisible) {
          formSectionWrapper.className = 'form-section-wrapper open'
          headerContainer.className = 'main-section-header section-header open'
          sectionNumberBox.className = 'section-number-box open'
          sectionTitleBox.className = 'section-title-box open'
          contentContainer.style.display = 'block'
        } else {
          formSectionWrapper.className = 'form-section-wrapper'
          headerContainer.className = 'main-section-header section-header not-open'
          sectionNumberBox.className = 'section-number-box'
          sectionTitleBox.className = 'section-title-box'
          contentContainer.style.display = 'none'
        }
      }

      // Close other sections when notes section is opened
      function closeOtherSections() {
        var otherSectionHeaders = document.querySelectorAll('.FormSection:not(#notesAndApproval) .main-section-header.open')
        otherSectionHeaders.forEach(function(header) {
          header.click()
        })
      }

      // Listen for other sections being opened to close notes section
      function setupSectionObserver() {
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var target = mutation.target
              if (target.classList.contains('main-section-header') && 
                  target.classList.contains('open') && 
                  !notesSection.contains(target) &&
                  isContentVisible) {
                // Another section was opened, close notes section
                isContentVisible = false
                updateSectionState()
              }
            }
          })
        })

        // Observe all FormSections for class changes on headers
        var pageContent = document.querySelector('.PageContent.form-content-with-pdf')
        if (pageContent) {
          observer.observe(pageContent, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
          })
        }
      }

      headerContainer.addEventListener('click', function() {
        isContentVisible = !isContentVisible
        if (isContentVisible) {
          closeOtherSections()
        }
        updateSectionState()
      })

      // Initialize as open and close other sections, then setup observer
      updateSectionState()
      closeOtherSections()
      setupSectionObserver()

      // Helper function to format/capitalize a user name
      function formatUserName(name) {
        if (!name) return 'Unbekannt'
        return name
          .split(' ')
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          })
          .join(' ')
      }

      // Helper function to get user name from email
      function getUserNameFromEmail() {
        var userEmail = JSON.parse(localStorage.auth).email.replace(/\./g, ' ')
        var userName = userEmail.substring(0, userEmail.indexOf('@'))
        return formatUserName(userName)
      }

      // Helper function to format date for display
      function formatDateForDisplay(dateString) {
        const date = new Date(dateString)
        return date.toLocaleDateString('de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        })
      }

      // Helper function to create save button
      function createSaveButton() {
        var btn = document.createElement('button')
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/><path d="M7 3v4a1 1 0 0 0 1 1h7"/></svg>'
        btn.title = 'Speichern'
        btn.style.background = 'none'
        btn.style.border = 'none'
        btn.style.cursor = 'pointer'
        btn.style.padding = '4px 8px'
        btn.style.color = 'rgba(0, 0, 0, 0.65)'
        btn.style.display = 'flex'
        btn.style.alignItems = 'center'
        btn.style.justifyContent = 'center'
        btn.addEventListener('mouseover', function () {
          btn.style.opacity = '0.7'
        })
        btn.addEventListener('mouseout', function () {
          btn.style.opacity = '1'
        })
        return btn
      }

      // Helper function to create cancel button
      function createCancelButton() {
        var btn = document.createElement('button')
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>'
        btn.title = 'Abbrechen'
        btn.style.background = 'none'
        btn.style.border = 'none'
        btn.style.cursor = 'pointer'
        btn.style.padding = '4px 8px'
        btn.style.color = 'rgba(0, 0, 0, 0.65)'
        btn.style.display = 'flex'
        btn.style.alignItems = 'center'
        btn.style.justifyContent = 'center'
        btn.addEventListener('mouseover', function () {
          btn.style.opacity = '0.7'
        })
        btn.addEventListener('mouseout', function () {
          btn.style.opacity = '1'
        })
        return btn
      }

      // Helper function to auto-resize textarea
      function autoResizeTextarea(textarea) {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
      }

      // Helper function to setup auto-resize on a textarea
      function setupAutoResize(textarea) {
        textarea.style.overflow = 'hidden'
        textarea.addEventListener('input', function () {
          autoResizeTextarea(textarea)
        })
        // Initial resize
        setTimeout(function () {
          autoResizeTextarea(textarea)
        }, 0)
      }

      // Helper function to disable/enable all note action buttons
      function setNoteButtonsDisabled(disabled) {
        var opacity = disabled ? '0.5' : '1'
        var cursor = disabled ? 'not-allowed' : 'pointer'
        
        // Unified add button
        unifiedAddButton.disabled = disabled
        unifiedAddButton.style.opacity = opacity
        unifiedAddButton.style.cursor = cursor
        
        // Save and cancel buttons in add form
        saveAddButton.disabled = disabled
        saveAddButton.style.opacity = opacity
        saveAddButton.style.cursor = cursor
        cancelAddButton.disabled = disabled
        cancelAddButton.style.opacity = opacity
        cancelAddButton.style.cursor = cursor
        
        // Edit mode buttons (if any exist)
        var editModeActions = document.querySelectorAll('.edit-mode-actions button')
        editModeActions.forEach(function(btn) {
          btn.disabled = disabled
          btn.style.opacity = opacity
          btn.style.cursor = cursor
        })
        
        // Menu buttons and dropdown options in note cards
        var noteCards = document.querySelectorAll('.note-card')
        noteCards.forEach(function(card) {
          var menuBtn = card.querySelector('button[title="Aktionen"]')
          if (menuBtn) {
            menuBtn.disabled = disabled
            menuBtn.style.opacity = disabled ? '0.3' : '0.6'
            menuBtn.style.cursor = cursor
          }
          var dropdownBtns = card.querySelectorAll('.note-dropdown button')
          dropdownBtns.forEach(function(btn) {
            btn.disabled = disabled
            btn.style.opacity = opacity
            btn.style.cursor = cursor
          })
        })
      }

      // Notes container for the note cards
      var notesCardsContainer = document.createElement('div')
      notesCardsContainer.id = 'notes-cards-container'

      // Notes Header with title and add button
      var notesHeader = document.createElement('div')
      notesHeader.id = 'notes-header'
      notesHeader.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 12px;
        margin-top: 12px;
      `
      
      var notesTitle = document.createElement('h3')
      notesTitle.textContent = 'Notizen'
      notesTitle.style.cssText = `
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: rgba(0, 0, 0, 0.85);
      `

      // Unified Add Button with Dropdown (top right)
      var unifiedAddContainer = document.createElement('div')
      unifiedAddContainer.id = 'unified-add-container'
      unifiedAddContainer.style.cssText = `
        position: relative;
        display: flex;
      `

      var unifiedAddButton = document.createElement('button')
      unifiedAddButton.id = 'unified-add-button'
      unifiedAddButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14M5 12h14"/>
        </svg>
      `
      unifiedAddButton.style.cssText = `
        display: flex;
        align-items: center;
        padding: 8px 14px;
        font-size: 13px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        background-color: transparent;
        border: none;
        border-radius: 6px;
        cursor: pointer;
      `
      unifiedAddButton.addEventListener('mouseover', function () {
        unifiedAddButton.style.backgroundColor = 'rgba(0, 0, 0, 0.14)'
      })
      unifiedAddButton.addEventListener('mouseout', function () {
        if (unifiedAddDropdown.style.display === 'none') {
          unifiedAddButton.style.backgroundColor = 'transparent'
        }
      })

      var unifiedAddDropdown = document.createElement('div')
      unifiedAddDropdown.id = 'unified-add-dropdown'
      unifiedAddDropdown.style.cssText = `
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        margin-top: 4px;
        background-color: #ffffff;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        z-index: 1000;
        min-width: 160px;
        overflow: hidden;
      `

      function createAddDropdownItem(icon, text, onClick) {
        var item = document.createElement('button')
        item.innerHTML = icon + '<span style="margin-left: 10px;">' + text + '</span>'
        item.style.cssText = `
          display: flex;
          align-items: center;
          width: 100%;
          padding: 10px 14px;
          border: none;
          background: none;
          cursor: pointer;
          text-align: left;
          font-size: 13px;
          color: #333;
          transition: background-color 0.15s;
        `
        item.addEventListener('mouseover', function () {
          item.style.backgroundColor = '#f5f5f5'
        })
        item.addEventListener('mouseout', function () {
          item.style.backgroundColor = 'transparent'
        })
        item.addEventListener('click', function (e) {
          e.stopPropagation()
          unifiedAddDropdown.style.display = 'none'
          unifiedAddButton.style.backgroundColor = 'transparent'
          onClick()
        })
        return item
      }

      var addNoteItem = createAddDropdownItem(
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>',
        'Notiz',
        function () {
          closeAllEditModes()
          // Remove empty state if it exists
          var emptyStateEl = document.getElementById('notes-empty-state')
          if (emptyStateEl) emptyStateEl.remove()
          addNoteForm.style.display = 'block'
          addNoteTextarea.focus()
        }
      )

      var addDocumentItem = createAddDropdownItem(
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M12 18v-6"/><path d="m9 15 3-3 3 3"/></svg>',
        'Anhang',
        function () {
          triggerFileUpload()
        }
      )

      unifiedAddDropdown.appendChild(addNoteItem)
      unifiedAddDropdown.appendChild(addDocumentItem)

      unifiedAddButton.addEventListener('click', function (e) {
        e.stopPropagation()
        var isVisible = unifiedAddDropdown.style.display === 'block'
        unifiedAddDropdown.style.display = isVisible ? 'none' : 'block'
        unifiedAddButton.style.backgroundColor = isVisible ? 'transparent' : 'rgba(0, 0, 0, 0.14)'
      })

      document.addEventListener('click', function (e) {
        if (!unifiedAddContainer.contains(e.target)) {
          unifiedAddDropdown.style.display = 'none'
          unifiedAddButton.style.backgroundColor = 'transparent'
        }
      })

      unifiedAddContainer.appendChild(unifiedAddButton)
      unifiedAddContainer.appendChild(unifiedAddDropdown)

      // Add Note Form (initially hidden)
      var addNoteForm = document.createElement('div')
      addNoteForm.id = 'add-note-form'
      addNoteForm.style.display = 'none'
      addNoteForm.style.marginBottom = '16px'
      addNoteForm.style.padding = '12px'
      addNoteForm.style.backgroundColor = '#fff'
      addNoteForm.style.borderRadius = '4px'
      addNoteForm.style.border = '1px solid #eee'

      var addNoteTextarea = document.createElement('textarea')
      addNoteTextarea.style.padding = '8px 16px'
      addNoteTextarea.style.borderWidth = '2px'
      addNoteTextarea.style.borderColor = 'rgb(238, 238, 238)'
      addNoteTextarea.style.width = '100%'
      addNoteTextarea.style.borderRadius = '4px'
      addNoteTextarea.style.minHeight = '60px'
      addNoteTextarea.style.resize = 'none'
      addNoteTextarea.placeholder = 'Notiz eingeben...'
      setupAutoResize(addNoteTextarea)

      // Header with title and action buttons
      var addNoteHeader = document.createElement('div')
      addNoteHeader.style.display = 'flex'
      addNoteHeader.style.justifyContent = 'space-between'
      addNoteHeader.style.alignItems = 'center'
      addNoteHeader.style.marginBottom = '8px'

      var addNoteTitle = document.createElement('span')
      addNoteTitle.textContent = 'Neue Notiz'
      addNoteTitle.style.fontSize = '12px'
      addNoteTitle.style.color = '#666'
      addNoteTitle.style.fontWeight = '500'

      var addNoteButtonsContainer = document.createElement('div')
      addNoteButtonsContainer.style.display = 'flex'
      addNoteButtonsContainer.style.gap = '4px'
      addNoteButtonsContainer.style.alignItems = 'center'

      var saveAddButton = createSaveButton()
      var cancelAddButton = createCancelButton()

      addNoteButtonsContainer.appendChild(saveAddButton)
      addNoteButtonsContainer.appendChild(cancelAddButton)
      addNoteHeader.appendChild(addNoteTitle)
      addNoteHeader.appendChild(addNoteButtonsContainer)

      addNoteForm.appendChild(addNoteHeader)
      addNoteForm.appendChild(addNoteTextarea)

      // Function to render notes
      function renderNotes(notes) {
        notesCardsContainer.innerHTML = ''
        // Re-add the form
        notesCardsContainer.appendChild(addNoteForm)
        
        // Show empty state if no notes
        if (!notes || notes.length === 0) {
          var emptyState = document.createElement('p')
          emptyState.style.cssText = `
            color: rgba(0, 0, 0, 0.45);
            font-size: 14px;
            margin: 0;
            padding: 8px 0;
          `
          emptyState.id = 'notes-empty-state'
          emptyState.textContent = 'Keine Notizen vorhanden'
          notesCardsContainer.appendChild(emptyState)
        } else {
          // Sort notes by createdAt, latest first
          var sortedNotes = notes.slice().sort(function (a, b) {
            var dateA = new Date(a.createdAt || a.created_at)
            var dateB = new Date(b.createdAt || b.created_at)
            return dateB - dateA
          })
          sortedNotes.forEach(function (note) {
            var noteCard = createNoteCard(note)
            notesCardsContainer.appendChild(noteCard)
          })
        }
      }

      // Function to create a note card
      function createNoteCard(note) {
        var card = document.createElement('div')
        card.className = 'note-card'
        card.dataset.noteId = note.id
        card.style.backgroundColor = '#fff'
        card.style.borderRadius = '4px'
        card.style.padding = '12px'
        card.style.marginBottom = '4px'
        card.style.border = '1px solid #eee'
        card.style.position = 'relative'

        // Header with metadata
        var header = document.createElement('div')
        header.style.display = 'flex'
        header.style.justifyContent = 'space-between'
        header.style.alignItems = 'flex-start'
        header.style.marginBottom = '8px'

        var metaInfo = document.createElement('div')

        // Created by and date
        var createdInfo = document.createElement('div')
        createdInfo.style.fontSize = '12px'
        createdInfo.style.color = '#666'
        createdInfo.innerHTML = '<strong>' + formatUserName(note.createdByName || note.created_by_name) + '</strong> &bull; ' + formatDateForDisplay(note.createdAt || note.created_at)

        metaInfo.appendChild(createdInfo)

        // Edited indicator
        if (note.lastModifiedAt || note.last_modified_at) {
          var editedInfo = document.createElement('div')
          editedInfo.style.fontSize = '11px'
          editedInfo.style.color = '#999'
          editedInfo.style.fontStyle = 'italic'
          editedInfo.style.marginTop = '2px'
          editedInfo.textContent = '(Bearbeitet von ' + formatUserName(note.lastModifiedByName || note.last_modified_by_name) + ' am ' + formatDateForDisplay(note.lastModifiedAt || note.last_modified_at) + ')'
          metaInfo.appendChild(editedInfo)
        }

        var isFixedNote = !!(note.isFixed || note.is_fixed)

        // Action menu (kebab menu)
        var actionsContainer = document.createElement('div')
        actionsContainer.style.position = 'relative'

        var menuButton = document.createElement('button')
        menuButton.innerHTML = '⋮'
        menuButton.title = 'Aktionen'
        menuButton.style.background = 'none'
        menuButton.style.border = 'none'
        menuButton.style.cursor = 'pointer'
        menuButton.style.fontSize = '18px'
        menuButton.style.padding = '4px 8px'
        menuButton.style.opacity = '0.6'
        menuButton.style.lineHeight = '1'
        menuButton.style.fontWeight = 'bold'
        menuButton.addEventListener('mouseover', function () {
          menuButton.style.opacity = '1'
        })
        menuButton.addEventListener('mouseout', function () {
          if (!dropdown.style.display || dropdown.style.display === 'none') {
            menuButton.style.opacity = '0.6'
          }
        })

        var dropdown = document.createElement('div')
        dropdown.style.display = 'none'
        dropdown.style.position = 'absolute'
        dropdown.style.top = '100%'
        dropdown.style.right = '0'
        dropdown.style.backgroundColor = '#fff'
        dropdown.style.border = '1px solid #eee'
        dropdown.style.borderRadius = '6px'
        dropdown.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)'
        dropdown.style.zIndex = '1000'
        dropdown.style.minWidth = '120px'
        dropdown.style.overflow = 'hidden'

        var editOption = document.createElement('button')
        editOption.textContent = 'Bearbeiten'
        editOption.style.display = 'block'
        editOption.style.width = '100%'
        editOption.style.padding = '10px 16px'
        editOption.style.border = 'none'
        editOption.style.background = 'none'
        editOption.style.cursor = 'pointer'
        editOption.style.textAlign = 'left'
        editOption.style.fontSize = '14px'
        editOption.style.color = '#333'
        editOption.addEventListener('mouseover', function () {
          editOption.style.backgroundColor = '#f5f5f5'
        })
        editOption.addEventListener('mouseout', function () {
          editOption.style.backgroundColor = 'transparent'
        })
        editOption.addEventListener('click', function (e) {
          e.stopPropagation()
          dropdown.style.display = 'none'
          menuButton.style.opacity = '0.6'
          enterEditMode(card, note)
        })

        var deleteOption = document.createElement('button')
        deleteOption.textContent = 'Löschen'
        deleteOption.style.display = 'block'
        deleteOption.style.width = '100%'
        deleteOption.style.padding = '10px 16px'
        deleteOption.style.border = 'none'
        deleteOption.style.background = 'none'
        deleteOption.style.cursor = 'pointer'
        deleteOption.style.textAlign = 'left'
        deleteOption.style.fontSize = '14px'
        deleteOption.style.color = '#e53935'
        deleteOption.addEventListener('mouseover', function () {
          deleteOption.style.backgroundColor = '#f5f5f5'
        })
        deleteOption.addEventListener('mouseout', function () {
          deleteOption.style.backgroundColor = 'transparent'
        })
        deleteOption.addEventListener('click', function (e) {
          e.stopPropagation()
          dropdown.style.display = 'none'
          menuButton.style.opacity = '0.6'
          if (confirm('Möchten Sie diese Notiz wirklich löschen?')) {
            deleteNote(note.id)
          }
        })

        if (!isFixedNote) {
          dropdown.appendChild(editOption)
          dropdown.appendChild(deleteOption)
        } else {
          menuButton.style.display = 'none'
        }

        menuButton.addEventListener('click', function (e) {
          e.stopPropagation()
          var isVisible = dropdown.style.display === 'block'
          // Close all other dropdowns first
          document.querySelectorAll('.note-card .note-dropdown').forEach(function (d) {
            d.style.display = 'none'
          })
          dropdown.style.display = isVisible ? 'none' : 'block'
          menuButton.style.opacity = isVisible ? '0.6' : '1'
        })

        dropdown.className = 'note-dropdown'

        // Close dropdown when clicking outside
        document.addEventListener('click', function (e) {
          if (!actionsContainer.contains(e.target)) {
            dropdown.style.display = 'none'
            menuButton.style.opacity = '0.6'
          }
        })

        actionsContainer.appendChild(menuButton)
        actionsContainer.appendChild(dropdown)

        header.appendChild(metaInfo)
        header.appendChild(actionsContainer)

        // Note text content
        var textContent = document.createElement('div')
        textContent.className = 'note-text-content'
        textContent.style.whiteSpace = 'pre-wrap'
        textContent.style.wordBreak = 'break-word'
        textContent.style.fontSize = '14px'
        textContent.style.lineHeight = '1.5'
        textContent.textContent = note.text

        card.appendChild(header)
        card.appendChild(textContent)

        return card
      }

      // Helper function to close add note form
      function closeAddNoteForm() {
        if (addNoteForm.style.display !== 'none') {
          addNoteTextarea.value = ''
          addNoteForm.style.display = 'none'
        }
      }

      // Helper function to close all edit modes
      function closeAllEditModes() {
        var editModeActions = document.querySelectorAll('.edit-mode-actions')
        editModeActions.forEach(function (editActions) {
          var card = editActions.closest('.note-card')
          if (card) {
            var actionsContainer = editActions.parentElement
            var menuButton = actionsContainer.querySelector('button:not(.edit-mode-actions button)')
            var textContent = card.querySelector('.note-text-content')
            
            // Find original text from data attribute on textarea
            var textarea = textContent.querySelector('textarea')
            if (textarea) {
              var originalText = textarea.dataset.originalText || textarea.value
              textContent.innerHTML = ''
              textContent.textContent = originalText
            }
            
            // Remove edit actions and restore menu
            editActions.remove()
            if (menuButton) {
              menuButton.style.display = 'block'
            }
          }
        })
      }

      // Function to enter edit mode
      function enterEditMode(card, note) {
        // Close add note form if open
        closeAddNoteForm()
        
        // Close any other edit modes
        closeAllEditModes()

        var textContent = card.querySelector('.note-text-content')
        var actionsContainer = card.querySelector('div[style*="position: relative"]')
        var menuButton = actionsContainer.querySelector('button')
        var dropdown = actionsContainer.querySelector('.note-dropdown')
        var originalText = note.text

        // Hide the menu button and dropdown
        menuButton.style.display = 'none'
        dropdown.style.display = 'none'

        // Create edit mode action buttons container
        var editActionsContainer = document.createElement('div')
        editActionsContainer.className = 'edit-mode-actions'
        editActionsContainer.style.display = 'flex'
        editActionsContainer.style.gap = '4px'
        editActionsContainer.style.alignItems = 'center'

        var saveButton = createSaveButton()
        var cancelButton = createCancelButton()

        editActionsContainer.appendChild(saveButton)
        editActionsContainer.appendChild(cancelButton)
        actionsContainer.appendChild(editActionsContainer)

        // Create edit textarea
        var editTextarea = document.createElement('textarea')
        editTextarea.value = originalText
        editTextarea.dataset.originalText = originalText
        editTextarea.style.width = '100%'
        editTextarea.style.padding = '8px'
        editTextarea.style.borderWidth = '2px'
        editTextarea.style.borderColor = 'rgb(238, 238, 238)'
        editTextarea.style.borderRadius = '4px'
        editTextarea.style.minHeight = '40px'
        editTextarea.style.resize = 'none'
        editTextarea.style.fontSize = '14px'
        setupAutoResize(editTextarea)

        // Replace text content with edit form
        textContent.innerHTML = ''
        textContent.appendChild(editTextarea)

        editTextarea.focus()

        function exitEditMode() {
          // Remove edit actions and restore menu button
          editActionsContainer.remove()
          menuButton.style.display = 'block'
          textContent.innerHTML = ''
          textContent.textContent = originalText
        }

        cancelButton.addEventListener('click', function () {
          exitEditMode()
        })

        saveButton.addEventListener('click', async function () {
          var newText = editTextarea.value.trim()
          if (newText) {
            // Pass the original note to preserve creator info
            await updateNote(note.id, newText, note)
          } else {
            exitEditMode()
          }
        })
      }

      // Function to add a new note
      async function addNote(text) {
        setNoteButtonsDisabled(true)
        try {
          const response = await fetch(`${baseApiUrl}/api/invoiceNotes/set`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
            },
            body: JSON.stringify({
              eventType: 'NOTE_ADD',
              domain: getResolvedDomainFromToken(),
              invoiceHrId: window.location.pathname.split('/').pop(),
              text: text,
              userName: getUserNameFromEmail(),
            }),
          })

          if (response.ok) {
            const data = await response.json()
            addNoteTextarea.value = ''
            addNoteForm.style.display = 'none'
            // Add current user's name to the note
            var noteWithName = { ...data.note, createdByName: getUserNameFromEmail() }
            // Remove empty state if it exists
            var emptyStateEl = document.getElementById('notes-empty-state')
            if (emptyStateEl) emptyStateEl.remove()
            // Insert new note card at the beginning (after form)
            var newCard = createNoteCard(noteWithName)
            notesCardsContainer.insertBefore(newCard, addNoteForm.nextSibling)
          } else {
            console.error('Failed to add note')
          }
        } catch (error) {
          console.error('Error adding note:', error)
        } finally {
          setNoteButtonsDisabled(false)
        }
      }

      // Function to update a note
      async function updateNote(noteId, text, originalNote) {
        setNoteButtonsDisabled(true)        
        try {
          const response = await fetch(`${baseApiUrl}/api/invoiceNotes/set`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
            },
            body: JSON.stringify({
              eventType: 'NOTE_UPDATE',
              domain: getResolvedDomainFromToken(),
              invoiceHrId: window.location.pathname.split('/').pop(),
              noteId: noteId,
              text: text,
              userName: getUserNameFromEmail(),
            }),
          })

          if (response.ok) {
            const data = await response.json()
            // Preserve the original creator info and add current user as lastModifiedByName
            var noteWithName = { 
              ...data.note, 
              // Preserve original creator info from the original note
              createdByName: originalNote.createdByName || originalNote.created_by_name,
              createdAt: originalNote.createdAt || originalNote.created_at,
              // Add current user as the modifier
              lastModifiedByName: getUserNameFromEmail() 
            }
            // Replace the old card with updated one
            var oldCard = notesCardsContainer.querySelector('[data-note-id="' + noteId + '"]')
            if (oldCard) {
              var newCard = createNoteCard(noteWithName)
              oldCard.replaceWith(newCard)
            }
          } else {
            console.error('Failed to update note')
          }
        } catch (error) {
          console.error('Error updating note:', error)
        } finally {
          setNoteButtonsDisabled(false)
        }
      }

      // Function to delete a note
      async function deleteNote(noteId) {
        setNoteButtonsDisabled(true)
        
        try {
          const response = await fetch(`${baseApiUrl}/api/invoiceNotes/set`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
            },
            body: JSON.stringify({
              eventType: 'NOTE_DELETE',
              domain: getResolvedDomainFromToken(),
              invoiceHrId: window.location.pathname.split('/').pop(),
              noteId: noteId,
            }),
          })

          if (response.ok) {
            // Remove the card from DOM
            var card = notesCardsContainer.querySelector('[data-note-id="' + noteId + '"]')
            if (card) {
              card.remove()
            }
            // Check if there are any remaining notes, if not show empty state
            var remainingNotes = notesCardsContainer.querySelectorAll('.note-card')
            if (remainingNotes.length === 0) {
              var emptyState = document.createElement('p')
              emptyState.id = 'notes-empty-state'
              emptyState.style.cssText = `
                color: rgba(0, 0, 0, 0.45);
                font-size: 14px;
                margin: 0;
                padding: 8px 0;
              `
              emptyState.textContent = 'Keine Notizen vorhanden'
              notesCardsContainer.appendChild(emptyState)
            }
          } else {
            console.error('Failed to delete note')
          }
        } catch (error) {
          console.error('Error deleting note:', error)
        } finally {
          setNoteButtonsDisabled(false)
        }
      }

      // Event listeners for add note
      cancelAddButton.addEventListener('click', function () {
        addNoteTextarea.value = ''
        addNoteForm.style.display = 'none'
        // Show empty state again if there are no notes
        var remainingNotes = notesCardsContainer.querySelectorAll('.note-card')
        var existingEmptyState = document.getElementById('notes-empty-state')
        if (remainingNotes.length === 0 && !existingEmptyState) {
          var emptyState = document.createElement('p')
          emptyState.id = 'notes-empty-state'
          emptyState.style.cssText = `
            color: rgba(0, 0, 0, 0.45);
            font-size: 14px;
            margin: 0;
            padding: 8px 0;
          `
          emptyState.textContent = 'Keine Notizen vorhanden'
          notesCardsContainer.appendChild(emptyState)
        }
      })

      saveAddButton.addEventListener('click', function () {
        var text = addNoteTextarea.value.trim()
        if (text) {
          addNote(text)
        }
      })

      // File upload function (triggered from unified dropdown)
      function triggerFileUpload() {
        var fileInput = document.createElement('input')
        fileInput.type = 'file'
        fileInput.style.display = 'none'
        fileInput.multiple = true
        fileInput.click()
        fileInput.addEventListener('change', function (event) {
          var files = event.target.files
          if (files.length > 0) {
            var fileNames = Array.from(files).map((file) => file.name)
            console.log('Files selected:', fileNames)

            var userEmail = JSON.parse(localStorage.auth).email.replace(
              /\./g,
              ' '
            )
            var userName = userEmail.substring(0, userEmail.indexOf('@'))
            userName = userName
              .split(' ')
              .map(function (word) {
                return word.charAt(0).toUpperCase() + word.slice(1)
              })
              .join(' ')

            var currentDate = new Date()
            var formattedDate =
              currentDate.getFullYear() +
              '-' +
              (currentDate.getMonth() + 1).toString().padStart(2, '0') +
              '-' +
              currentDate.getDate().toString().padStart(2, '0') +
              ' ' +
              currentDate.getHours().toString().padStart(2, '0') +
              ':' +
              currentDate.getMinutes().toString().padStart(2, '0') +
              ':' +
              currentDate.getSeconds().toString().padStart(2, '0')

            var filesData = []
            var filesProcessed = 0

            Array.from(files).forEach((file) => {
              var reader = new FileReader()
              reader.onload = function (event) {
                filesData.push({
                  fileName: file.name,
                  fileBlob: event.target.result,
                })
                filesProcessed++
                if (filesProcessed === files.length) {
                  fetch(`${baseApiUrl}/api/invoiceNotes/set`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
                    },
                    body: JSON.stringify({
                      userName: userName,
                      formattedDate: formattedDate,
                      invoiceHrId: window.location.pathname.split('/').pop(),
                      domain: getResolvedDomainFromToken(),
                      files: filesData,
                      eventType: 'FILES_UPDATED', // Ensure the correct event type is sent
                    }),
                  }).then(function(response) {
                    if (response.ok) {
                      // Add uploaded files to the UI immediately
                      const invoiceId = window.location.pathname.split('/').pop()
                      const domain = getResolvedDomainFromToken()
                      
                      filesData.forEach(function(fileData) {
                        attachmentListContainer.appendChild(createAttachmentItem({
                          name: fileData.fileName,
                          webUrl: getSharePointFileUrl(domain, invoiceId, fileData.fileName)
                        }))
                      })
                    }
                  })
                }
              }
              reader.readAsDataURL(file)
            })
          }
        })
      }

      // Approval Section Container
      var approvalSection = document.createElement('div')
      approvalSection.id = 'approval-section'
      approvalSection.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin-top: 16px;
      `

      // Helper function to create approval card
      function createApprovalCard(id, title, isManagerApproval) {
        var card = document.createElement('div')
        card.className = 'approval-card'
        card.dataset.approvalId = id
        card.style.cssText = `
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 12px;
          background-color: #fff;
          border: 1px solid #e5e5e5;
          border-radius: 4px;
          transition: all 0.2s ease;
        `

        var leftSection = document.createElement('div')
        leftSection.style.cssText = `
          display: flex;
          align-items: center;
          gap: 8px;
        `

        var titleLabel = document.createElement('span')
        titleLabel.textContent = title
        titleLabel.style.cssText = `
          font-size: 14px;
          font-weight: 600;
          color: #1a1a1a;
        `

        var metaLabel = document.createElement('span')
        metaLabel.className = isManagerApproval ? 'manager-approval-meta' : 'approval-meta'
        metaLabel.style.cssText = `
          font-size: 11px;
          color: #999;
          display: none;
        `

        leftSection.appendChild(titleLabel)
        leftSection.appendChild(metaLabel)

        // Toggle switch
        var toggleWrapper = document.createElement('label')
        toggleWrapper.style.cssText = `
          position: relative;
          display: inline-block;
          width: 48px;
          height: 26px;
          flex-shrink: 0;
        `

      var checkbox = document.createElement('input')
      checkbox.type = 'checkbox'
        checkbox.id = id
        checkbox.style.cssText = `
          opacity: 0;
          width: 0;
          height: 0;
        `

        var slider = document.createElement('span')
        slider.className = 'toggle-slider'
        slider.style.cssText = `
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          opacity: 0.5;
          transition: 0.3s;
          border-radius: 26px;
        `

        var sliderDot = document.createElement('span')
        sliderDot.className = 'toggle-dot'
        sliderDot.style.cssText = `
          position: absolute;
          content: "";
          height: 20px;
          width: 20px;
          left: 3px;
          bottom: 3px;
          background-color: white;
          transition: 0.3s;
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        `

        slider.appendChild(sliderDot)
        toggleWrapper.appendChild(checkbox)
        toggleWrapper.appendChild(slider)

        // Toggle state change
        checkbox.addEventListener('change', function() {
          if (this.checked) {
            slider.style.backgroundColor = '#22c55e'
            sliderDot.style.transform = 'translateX(22px)'
          } else {
            slider.style.backgroundColor = '#ccc'
            sliderDot.style.transform = 'translateX(0)'
          }
        })

        card.appendChild(leftSection)
        card.appendChild(toggleWrapper)

        return { card, checkbox, metaLabel, slider, sliderDot }
      }

      // Create normal approval card
      var normalApproval = createApprovalCard('freigegeben', 'Freigabe', false)
      var checkboxContainer = normalApproval.card
      var checkbox = normalApproval.checkbox
      var clickedByLabel = normalApproval.metaLabel
      var normalSlider = normalApproval.slider
      var normalSliderDot = normalApproval.sliderDot

      // Create manager approval card
      var managerApproval = createApprovalCard('freigegebenManagerApproval', '2. Freigabe', true)
      var firstInternalApprovalUI = enhanceFirstInternalManagerApproval(managerApproval, function () {
        return window.__luxInvoiceApprovalLoadData || null
      })
      var checkboxManagerApprovaContainer =
        firstInternalApprovalUI && firstInternalApprovalUI.rowWrapper
          ? firstInternalApprovalUI.rowWrapper
          : managerApproval.card
      checkboxManagerApprovaContainer.style.display = 'none'
      var checkboxManagerApproval = managerApproval.checkbox
      var clickedByLabelManagerApproval = managerApproval.metaLabel
      var managerSlider = managerApproval.slider
      var managerSliderDot = managerApproval.sliderDot

      function handleCheckboxChange(event) {
        var checkboxId = this.id || event.target.id
        var wantChecked = this.checked

        if (checkboxId === 'freigegeben' && wantChecked) {
          var baseManagerPrep = luxPrepareManagerApprovalClick('base')
          if (!baseManagerPrep.allowed) {
            this.checked = false
            normalSlider.style.backgroundColor = '#ccc'
            normalSliderDot.style.transform = 'translateX(0)'
            if (baseManagerPrep.message) alert(baseManagerPrep.message)
            return
          }
          if (baseManagerPrep.alsoCheck && baseManagerPrep.alsoCheck.length) {
            luxProgrammaticCheckApprovalSlots(baseManagerPrep.alsoCheck)
          }
          luxMarkApprovalCheckedByCurrentUser('base')
        } else if (checkboxId === 'freigegeben' && !wantChecked) {
          luxUnmarkApprovalCheckedByCurrentUser('base')
          if (window.__luxInvoiceNote) {
            window.__luxInvoiceNote.checked = false
          }
        }

        if (checkboxId === 'freigegebenManagerApproval' && wantChecked) {
          var togglePrep =
            firstInternalApprovalUI && firstInternalApprovalUI.prepareManagerToggle
              ? firstInternalApprovalUI.prepareManagerToggle(wantChecked)
              : { allowed: true }
          if (!togglePrep.allowed) {
            this.checked = false
            managerSlider.style.backgroundColor = '#ccc'
            managerSliderDot.style.transform = 'translateX(0)'
            if (togglePrep.message) {
              alert(togglePrep.message)
            }
            return
          }
          if (togglePrep.alsoCheck && togglePrep.alsoCheck.length) {
            luxProgrammaticCheckApprovalSlots(togglePrep.alsoCheck)
          }
          luxMarkApprovalCheckedByCurrentUser('first')
        } else if (checkboxId === 'freigegebenManagerApproval' && !wantChecked) {
          luxUnmarkApprovalCheckedByCurrentUser('first')
          if (window.__luxInvoiceNote) {
            window.__luxInvoiceNote.checkedManagerApproval = false
          }
        }

        var userEmail = JSON.parse(localStorage.auth).email.replace(
          /\./g,
          ' '
        )
        var userName = userEmail.substring(0, userEmail.indexOf('@'))
        userName = userName
          .split(' ')
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1)
          })
          .join(' ')
        var currentDate = new Date()
        var formattedDate = luxFormatInvoiceNoteNow()

        if(checkboxId == 'freigegeben'){
          clickedByLabel.style.display = this.checked ? 'inline' : 'none'
          clickedByLabel.textContent = this.checked
            ? '— ' + userName + ', ' + formattedDate
            : ''
        } else if(checkboxId == 'freigegebenManagerApproval'){
          // Show actor + timestamp immediately; confirmed again after save succeeds.
          if (wantChecked) {
            clickedByLabelManagerApproval.textContent = '— ' + userName + ', ' + formattedDate
            clickedByLabelManagerApproval.style.display = 'inline'
          } else {
            clickedByLabelManagerApproval.textContent = ''
            clickedByLabelManagerApproval.style.display = 'none'
          }
        }

        var managerMetaOnSuccess =
          checkboxId === 'freigegebenManagerApproval' && wantChecked
            ? '— ' + userName + ', ' + formattedDate
            : null
        var runSecondInternalFollowUpAfterSave =
          checkboxId === 'freigegebenManagerApproval' &&
          wantChecked &&
          window.__luxInvoiceApprovalLoadData &&
          window.__luxInvoiceApprovalLoadData.requiresSecondInternalApproval

        var xhr = new XMLHttpRequest()
        var clickedCheckboxEl = this
        if (checkboxId === 'freigegebenManagerApproval' && firstInternalApprovalUI) {
          if (firstInternalApprovalUI.setManagerApprovalSaving) {
            firstInternalApprovalUI.setManagerApprovalSaving(true)
          }
        }
        xhr.open('POST', `${baseApiUrl}/api/invoiceNotes/set`, true)
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.auth).token}`)
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
              console.log('Success:', xhr.responseText)
              if (checkboxId === 'freigegebenManagerApproval') {
                if (firstInternalApprovalUI) {
                  if (firstInternalApprovalUI.setManagerApprovalSaving) {
                    firstInternalApprovalUI.setManagerApprovalSaving(false)
                  }
                  if (firstInternalApprovalUI.applyManagerApprovalSavedVisual) {
                    firstInternalApprovalUI.applyManagerApprovalSavedVisual(
                      clickedCheckboxEl.checked,
                      managerMetaOnSuccess
                    )
                  }
                }
                if (window.__luxInvoiceApprovalLoadData) {
                  window.__luxInvoiceApprovalLoadData.firstInternalApprovalPersisted = true
                }
                if (window.secondInternalApprovalUI && window.secondInternalApprovalUI.setFirstTierComplete) {
                  window.secondInternalApprovalUI.setFirstTierComplete(!!clickedCheckboxEl.checked)
                }
                if (runSecondInternalFollowUpAfterSave && clickedCheckboxEl.checked) {
                  if (
                    window.secondInternalApprovalUI &&
                    window.secondInternalApprovalUI.onFirstApprovalChecked
                  ) {
                    window.secondInternalApprovalUI.onFirstApprovalChecked()
                  }
                }
              }
              if (
                checkboxId === 'freigegebenManagerApproval' &&
                wantChecked &&
                window.__luxInvoiceNote
              ) {
                window.__luxInvoiceNote.checkedManagerApproval = true
                window.__luxInvoiceNote.changedManagerApprovalBy = userName
                window.__luxInvoiceNote.changedManagerApprovalAt = currentDate.toISOString()
              }
              if (
                checkboxId === 'freigegebenManagerApproval' &&
                !wantChecked &&
                window.__luxInvoiceNote
              ) {
                window.__luxInvoiceNote.checkedManagerApproval = false
                window.__luxInvoiceNote.changedManagerApprovalBy = null
                luxUnmarkApprovalCheckedByCurrentUser('first')
              }
              if (
                checkboxId === 'freigegeben' &&
                wantChecked &&
                window.__luxInvoiceNote
              ) {
                window.__luxInvoiceNote.checked = true
                window.__luxInvoiceNote.changedBy = userName
                window.__luxInvoiceNote.changedAt = currentDate.toISOString()
              }
              if (
                checkboxId === 'freigegeben' &&
                !wantChecked &&
                window.__luxInvoiceNote
              ) {
                window.__luxInvoiceNote.checked = false
                window.__luxInvoiceNote.changedBy = null
                luxUnmarkApprovalCheckedByCurrentUser('base')
              }
              if (checkboxId === 'freigegeben' && wantChecked && clickedCheckboxEl.checked) {
                if (
                  firstInternalApprovalUI &&
                  firstInternalApprovalUI.onBaseApprovalChecked
                ) {
                  firstInternalApprovalUI.onBaseApprovalChecked()
                } else if (
                  window.secondInternalApprovalUI &&
                  window.secondInternalApprovalUI.onFirstApprovalChecked
                ) {
                  window.secondInternalApprovalUI.onFirstApprovalChecked()
                }
              }
              if (
                checkboxId === 'freigegebenManagerApproval' &&
                firstInternalApprovalUI &&
                firstInternalApprovalUI.refreshMenu
              ) {
                firstInternalApprovalUI.refreshMenu()
              }
            } else {
              console.error('Error:', xhr.statusText)
              if (checkboxId === 'freigegeben' && wantChecked) {
                luxUnmarkApprovalCheckedByCurrentUser('base')
                clickedCheckboxEl.checked = false
                normalSlider.style.backgroundColor = '#ccc'
                normalSliderDot.style.transform = 'translateX(0)'
                clickedByLabel.style.display = 'none'
                clickedByLabel.textContent = ''
                alert(
                  xhr.status === 403
                    ? 'Sie haben bereits eine Freigabe erteilt. Weitere Freigaben können nur übersprungen werden.'
                    : 'Freigabe konnte nicht gespeichert werden.'
                )
              }
              if (checkboxId === 'freigegeben' && !wantChecked) {
                // Uncheck failed — restore previous checked-by-me state
                luxMarkApprovalCheckedByCurrentUser('base')
                if (window.__luxInvoiceNote) {
                  window.__luxInvoiceNote.checked = true
                }
                clickedCheckboxEl.checked = true
                normalSlider.style.backgroundColor = '#22c55e'
                normalSliderDot.style.transform = 'translateX(22px)'
              }
              if (checkboxId === 'freigegebenManagerApproval') {
                if (wantChecked) luxUnmarkApprovalCheckedByCurrentUser('first')
                else {
                  luxMarkApprovalCheckedByCurrentUser('first')
                  if (window.__luxInvoiceNote) {
                    window.__luxInvoiceNote.checkedManagerApproval = true
                  }
                }
                clickedCheckboxEl.checked = !wantChecked
                if (firstInternalApprovalUI) {
                  if (firstInternalApprovalUI.setManagerApprovalSaving) {
                    firstInternalApprovalUI.setManagerApprovalSaving(false)
                  }
                  if (firstInternalApprovalUI.applyManagerApprovalSavedVisual) {
                    firstInternalApprovalUI.applyManagerApprovalSavedVisual(
                      clickedCheckboxEl.checked,
                      null
                    )
                  }
                }
                if (window.secondInternalApprovalUI && window.secondInternalApprovalUI.setFirstTierComplete) {
                  window.secondInternalApprovalUI.setFirstTierComplete(!!clickedCheckboxEl.checked)
                }
                alert(
                  xhr.status === 403 && wantChecked
                    ? 'Sie haben bereits eine Freigabe erteilt. Weitere Freigaben können nur übersprungen werden.'
                    : '2. Freigabe konnte nicht gespeichert werden.'
                )
              }
            }
          }
        }
        
        const eventTypeByCheckboxId ={
          'freigegeben':{
            true: 'ACCEPTED',
            false: 'DENIED',
          },
          'freigegebenManagerApproval': {
            true: 'MANAGER_APPROVAL_REQUIRED_ACCEPTED',
            false: 'MANAGER_APPROVAL_REQUIRED_DENIED',
          },
        }

        xhr.send(
          JSON.stringify({
            userName: userName,
            date: formattedDate,
            invoiceHrId: window.location.pathname.split('/').pop(),
            domain: getResolvedDomainFromToken(),
            eventType:  eventTypeByCheckboxId[checkboxId][this.checked],
          })
        )
      }
      checkbox.addEventListener('change', handleCheckboxChange)
      checkboxManagerApproval.addEventListener('change', handleCheckboxChange)

      clickedByLabel.style.display = 'none'
      clickedByLabelManagerApproval.style.display = 'none'

      // Create a container for the list of attachment names
      var attachmentListContainer = document.createElement('div')
      attachmentListContainer.style.marginTop = '8px'
      attachmentListContainer.style.fontSize = '14px'
      attachmentListContainer.style.color = '#333'

      // SharePoint site mapping by domain
      var sharepointSites = {
        'erste-hausverwaltung-dus': 'DMS-Duesseldorf',
        'hauscon': 'NeovaroDMSHauscon',
        'cig': 'DMS-Capitol',
        'zieglmeier': 'DMS-Zieglmeier',
        'erste-hausverwaltung-2': 'NeovaroDMSTesting',
        'ehv-service': 'EHVDMSTesting',
        'ehv-test': 'DMS-EHV-Test',
        'sgv-murr': 'DMS-SGVMurr',
        'hv-tesche': 'DMS-HVTesche',
        'verwey': 'DMS-Verwey',
        'bachem': 'DMS-Bachem',
        'oehler': 'DMS-Oehler',
        'fraenken': 'DMS-Fraenken-GmbH',
        'bhv': 'DMS-BHV',
        'benz-walker': 'DMS-Benz-Walker',
        'riebeling': 'DMS-Riebeling', //TODO DOS
      }

      var sharePointDocsLibrary = 'Freigegebene Dokumente'
      var sharePointInvoiceAttachmentsPath = '07_Sonstiges/Lux/Rechnungsanhänge'

      // Helper function to get SharePoint preview URL for a file
      function getSharePointFileUrl(domain, invoiceId, fileName) {
        var siteName = sharepointSites[domain]
        if (!siteName) return null
        return `https://erstehausverwaltung.sharepoint.com/sites/${siteName}/${encodeURI(sharePointDocsLibrary)}/${sharePointInvoiceAttachmentsPath.split('/').map(encodeURIComponent).join('/')}/${encodeURIComponent(invoiceId)}/${encodeURIComponent(fileName)}`
      }

      // Helper function to get SharePoint folder URL (AllItems view)
      function getSharePointFolderUrl(domain, invoiceId) {
        var siteName = sharepointSites[domain]
        if (!siteName) return '/'
        var folderPath = `/sites/${siteName}/${sharePointDocsLibrary}/${sharePointInvoiceAttachmentsPath}/${invoiceId}`
        return `https://erstehausverwaltung.sharepoint.com/sites/${siteName}/${encodeURI(sharePointDocsLibrary)}/Forms/AllItems.aspx?id=${encodeURIComponent(folderPath)}`
      }

      // Helper function to create an attachment item
      // attachment can be an object with { name, webUrl } or just a string (for newly uploaded files)
      function createAttachmentItem(attachment) {
        var name = typeof attachment === 'string' ? attachment : attachment.name
        var previewUrl = typeof attachment === 'object' ? attachment.webUrl : null
        
        var attachmentItem = document.createElement('div')
        attachmentItem.style.display = 'flex'
        attachmentItem.style.alignItems = 'center'
        
        var attachmentLink = document.createElement('a')
        
        // Create inline SVG for document icon
        var attachmentIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        attachmentIcon.setAttribute('width', '15')
        attachmentIcon.setAttribute('height', '15')
        attachmentIcon.setAttribute('viewBox', '0 0 24 24')
        attachmentIcon.setAttribute('fill', 'none')
        attachmentIcon.setAttribute('stroke', 'currentColor')
        attachmentIcon.setAttribute('stroke-width', '2')
        attachmentIcon.setAttribute('stroke-linecap', 'round')
        attachmentIcon.setAttribute('stroke-linejoin', 'round')
        attachmentIcon.style.marginRight = '8px'
        attachmentIcon.style.flexShrink = '0'
        attachmentIcon.style.color = '#666'
        attachmentIcon.innerHTML = '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>'

        if (previewUrl) {
          // Open file in SharePoint viewer for preview
          attachmentLink.href = previewUrl
          attachmentLink.target = '_blank'
          attachmentLink.rel = 'noopener noreferrer'
        } else {
          // Fallback: open SharePoint folder
          attachmentLink.onclick = function () {
            const invoiceId = window.location.pathname.split('/').pop()
            const domain = getResolvedDomainFromToken()
            window.open(getSharePointFolderUrl(domain, invoiceId), '_blank')
          }
        }
        attachmentLink.style.textDecoration = 'none'
        attachmentLink.style.color = '#333'
        attachmentLink.style.cursor = 'pointer'
        attachmentLink.textContent = name

        attachmentItem.appendChild(attachmentIcon)
        attachmentItem.appendChild(attachmentLink)
        return attachmentItem
      }

      function showInvoiceNotesFetchError(details) {
        var lines = [
          'Fehler beim Laden der Rechnungsdaten (Notizen / Freigabe / Anhänge).',
          '',
        ]
        if (details.invoiceId) lines.push('Rechnung: ' + details.invoiceId)
        if (details.domain) lines.push('Domain: ' + details.domain)
        if (details.status != null) {
          lines.push(
            'HTTP ' +
              details.status +
              (details.statusText ? ' (' + details.statusText + ')' : '')
          )
        }
        if (details.serverError) lines.push('Meldung: ' + details.serverError)
        if (details.serverCode) lines.push('Code: ' + details.serverCode)
        if (details.clientError) lines.push('Client: ' + details.clientError)
        if (details.status === 401) {
          lines.push('Hinweis: Bitte abmelden und wieder anmelden.')
        }
        lines.push('', 'Bitte diesen Text an die IT weiterleiten (Screenshot reicht).')
        console.error('Lux invoiceNotes/get failed', details)
        alert(lines.join('\n'))
      }

      async function fetchInvoiceNotesAndApproval() {
        const invoiceId = window.location.pathname.split('/').pop()
        let domain
        try {
          domain = getResolvedDomainFromToken()
          const response = await fetch(`${baseApiUrl}/api/invoiceNotes/get`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
            },
            body: JSON.stringify({
              domain: domain,
              invoiceHrId: invoiceId,
            }),
          })

          if (window.invoiceSectionFetchState) {
            window.invoiceSectionFetchState.markNotesAndApprovalFetched()
          }

          if (!response.ok) {
            let serverError = ''
            let serverCode = ''
            try {
              const errBody = await response.json()
              serverError = errBody && errBody.error ? String(errBody.error) : ''
              serverCode = errBody && errBody.code ? String(errBody.code) : ''
            } catch (_) {
              // Response body may not be JSON
            }
            showInvoiceNotesFetchError({
              invoiceId: invoiceId,
              domain: domain,
              status: response.status,
              statusText: response.statusText,
              serverError: serverError,
              serverCode: serverCode,
            })
            return
          }

          const data = await response.json()
            if (data.invoiceLoadError) {
              console.warn(
                'Lux invoiceNotes/get: Impower-Rechnung/Objekt übersprungen',
                data.invoiceLoadError
              )
            }
            if (data.propertyId != null) {
              window.invoiceSectionPropertyId = data.propertyId
            }
            window.invoiceSectionPropertyContext = {
              invoiceId: currentInvoiceId,
              propertyId: data.propertyId != null ? data.propertyId : null,
              propertyHrId: data.propertyHrId != null ? data.propertyHrId : null
            }
            var invoiceNote =
              data.invoiceNote && data.invoiceNote.length > 0
                ? data.invoiceNote[0]
                : null
            window.__luxInvoiceNote = invoiceNote
            luxHydrateManagerCheckedSlotsFromNote(invoiceNote)
            var invoiceAttachments =
              (data.invoiceAttachments && data.invoiceAttachments.value) || []
            if (data.invoiceAttachmentsError) {
              console.warn(
                '[Lux invoice attachments]',
                data.invoiceAttachmentsError
              )
              var attachmentErrorEl = document.createElement('div')
              attachmentErrorEl.className = 'lux-invoice-attachments-error'
              attachmentErrorEl.textContent =
                'Anhänge konnten nicht geladen werden. Bitte versuchen Sie es später erneut.'
              attachmentErrorEl.style.cssText =
                'margin-top:4px;font-size:12px;color:#b45309;line-height:1.35;'
              attachmentListContainer.appendChild(attachmentErrorEl)
            }
            var invoiceApprovingManagerEmails = data.invoiceApprovingManagerEmails || []
            window.__luxInvoiceApprovalLoadData = data
            const maximumInvoiceAmount = data.maximumInvoiceAmount
            const capexLimit = data.capexLimit
            const totalGross = data.totalGross != null ? data.totalGross * -1 : 0
            if (firstInternalApprovalUI && firstInternalApprovalUI.applyLoadState) {
              firstInternalApprovalUI.applyLoadState(data)
            } else {
              // Fallback when enhanceFirstInternalManagerApproval did not wrap the card
              checkboxManagerApprovaContainer.style.display = data.requiresFirstInternalApproval
                ? 'block'
                : 'none'
            }
            if((data.externalApprovalEnabled ?? (capexLimit > 0)) && (capexLimit === 0 || totalGross >= capexLimit)){
              if (externalApprovalUI.externalApprovalCardContainer) externalApprovalUI.externalApprovalCardContainer.style.display = 'block'
              if (externalApprovalUI.externalApprovalBadge) externalApprovalUI.externalApprovalBadge.style.display = 'inline-block'
              if (externalApprovalUI.setSkipApprovalAvailability) {
                externalApprovalUI.setSkipApprovalAvailability(!!data.allowSkipExternalApproval)
              }
              if (data.skippedExternalApproval) {
                if (data.allowSkipExternalApproval && externalApprovalUI.setExternalApprovalSkipped) {
                  externalApprovalUI.setExternalApprovalSkipped()
                } else if (!data.allowSkipExternalApproval && externalApprovalUI.clearPersistedSkipOverride) {
                  externalApprovalUI.clearPersistedSkipOverride()
                }
              }
              // if (externalApprovalUI.externalApprovalButtonRow) externalApprovalUI.externalApprovalButtonRow.style.display = 'block'
            }
            if (data.currentUserContactId != null) {
              window.__luxCurrentContactId = data.currentUserContactId
            }
            if (firstInternalApprovalUI && firstInternalApprovalUI.refreshCheckboxDisabled) {
              firstInternalApprovalUI.refreshCheckboxDisabled()
            }
            if (window.secondInternalApprovalUI && window.secondInternalApprovalUI.applyLoadState) {
              window.secondInternalApprovalUI.applyLoadState(data, invoiceNote)
            }
            luxLogApprovalDebugCapabilities(data, invoiceNote)
            // Render notes entries from the same response
            renderNotes(data.noteEntries || [])
            aiNoteIndicatorUI.updateAiNoteIndicator(data.aiNoteEntries || [])
            checkbox.checked = invoiceNote?.checked || false
            checkboxManagerApproval.checked = invoiceNote?.checkedManagerApproval || false
            
            // Fetch tax exemption status from separate endpoint
            if (data.counterpartContactId) {
              fetchTaxExemptionStatus(data.counterpartContactId)
            }
            
            // Update normal approval visual state
            if (invoiceNote?.checked) {
              normalSlider.style.backgroundColor = '#22c55e'
              normalSliderDot.style.transform = 'translateX(22px)'
              // Naive DB times are UTC; format DST-aware for Europe/Berlin.
              // Prefer checkedAt; fall back to changedAt for older update-path rows.
              var contentAt =
                invoiceNote.checkedAt || invoiceNote.changedAt
              var contentBy =
                invoiceNote.checkedBy || invoiceNote.changedBy
              var formattedDate = luxFormatInvoiceNoteDateTime(contentAt)
              clickedByLabel.textContent = '— ' + contentBy + ', ' + formattedDate
              clickedByLabel.style.display = 'inline'
            }
            
            // Update manager approval visual state
            if(invoiceNote?.checkedManagerApproval){
              managerSlider.style.backgroundColor = '#22c55e'
              managerSliderDot.style.transform = 'translateX(22px)'
              var managerAt =
                invoiceNote.checkedManagerApprovalAt ||
                invoiceNote.changedManagerApprovalAt
              var managerBy =
                invoiceNote.checkedManagerApprovalBy ||
                invoiceNote.changedManagerApprovalBy
              var managerFormattedDate = luxFormatInvoiceNoteDateTime(managerAt)
              clickedByLabelManagerApproval.textContent =
                '— ' + managerBy + ', ' + managerFormattedDate
              clickedByLabelManagerApproval.style.display = 'inline'
            }

            // Render the list of attachments
            if (invoiceAttachments && invoiceAttachments.length > 0) {
              invoiceAttachments.forEach((attachment) => {
                attachmentListContainer.appendChild(createAttachmentItem(attachment))
              })
            }
        } catch (error) {
          if (window.invoiceSectionFetchState) {
            window.invoiceSectionFetchState.markNotesAndApprovalFetched()
          }
          showInvoiceNotesFetchError({
            invoiceId: invoiceId,
            domain: domain,
            clientError: error && error.message ? error.message : String(error),
          })
        }
      }

      fetchInvoiceNotesAndApproval()

      // Build content container
      // Create skeleton loader first (visible by default)
      var skeletonLoader = createSkeletonLoader()
      contentContainer.appendChild(skeletonLoader)

      // Create real content wrapper (hidden by default)
      var realContentWrapper = document.createElement('div')
      realContentWrapper.id = 'invoice-section-real-content'
      realContentWrapper.style.display = 'none'

      // 1. Approvals
      approvalSection.appendChild(checkboxContainer)
      approvalSection.appendChild(checkboxManagerApprovaContainer)
      window.secondInternalApprovalUI = secondInternalApprovalForInvoice(approvalSection)
      var externalApprovalUI = externalApprovalForInvoice(approvalSection, sectionTitle)
      window.onSecondInternalApprovalSkipped = function (result) {
        if (!result || !result.note) return
        var emptyStateEl = document.getElementById('notes-empty-state')
        if (emptyStateEl) emptyStateEl.remove()
        var noteWithName = {
          ...result.note,
          isFixed: true,
          createdByName: getUserNameFromEmail(),
        }
        var newCard = createNoteCard(noteWithName)
        notesCardsContainer.insertBefore(newCard, addNoteForm.nextSibling)
      }
      window.onExternalApprovalSkipped = function (result) {
        if (!result || !result.note) return
        var emptyStateEl = document.getElementById('notes-empty-state')
        if (emptyStateEl) emptyStateEl.remove()
        var noteWithName = {
          ...result.note,
          isFixed: true,
          createdByName: getUserNameFromEmail(),
        }
        var newCard = createNoteCard(noteWithName)
        notesCardsContainer.insertBefore(newCard, addNoteForm.nextSibling)
      }
      realContentWrapper.appendChild(approvalSection)
      
      // 2. Notes
      notesHeader.appendChild(notesTitle)
      notesHeader.appendChild(unifiedAddContainer)
      realContentWrapper.appendChild(notesHeader)
      notesCardsContainer.appendChild(addNoteForm)
      realContentWrapper.appendChild(notesCardsContainer)
      
      // 4. Documents
      realContentWrapper.appendChild(attachmentListContainer)
      
      // 5. Tasks (injected by taskListforInvoice at the end)

      contentContainer.appendChild(realContentWrapper)

      // Assemble notes section
      formSectionWrapper.appendChild(headerContainer)
      formSectionWrapper.appendChild(contentContainer)
      notesSection.appendChild(formSectionWrapper)

      // Insert into #scrollElement before the first FormSection
      var scrollElement = document.querySelector('#scrollElement')
      var firstFormSection = scrollElement ? scrollElement.querySelector('.FormSection') : null
      if (scrollElement && firstFormSection) {
        scrollElement.insertBefore(notesSection, firstFormSection)
      } else {
        pageContent.insertBefore(notesSection, pageContent.firstChild)
      }
    }
  }, 100)
}

/**
 * Open another invoice in a new tab (same host as the Impower app).
 */
function luxInvoiceEditUrlForHrId(invoiceHrId) {
  return (
    window.location.origin +
    '/invoice/edit/' +
    encodeURIComponent(String(invoiceHrId))
  )
}

/**
 * Inserts a German warning above Impower «Schritt 0» (first .FormSection with section number 0).
 * @param {string} [propertyLabel] — Objektbezeichnung für den Fließtext (optional)
 */
function mountLuxDuplicateInvoiceNumberBanner(
  invoiceNumber,
  othersRows,
  propertyLabel
) {
  if (!othersRows || othersRows.length === 0) return

  var tryMount = function () {
    var scroll = document.querySelector('#scrollElement')
    var stepZero = null
    if (scroll) {
      var nums = scroll.querySelectorAll('.FormSection .section-number')
      for (var i = 0; i < nums.length; i++) {
        var raw = String(nums[i].textContent || '').trim()
        var n = parseInt(raw.replace(/\D/g, ''), 10)
        if (n === 0) {
          stepZero = nums[i].closest('.FormSection')
          break
        }
      }
      if (!stepZero) {
        stepZero = scroll.querySelector('.FormSection')
      }
    }
    var anchor =
      stepZero ||
      (scroll && scroll.querySelector('.FormSection')) ||
      document.querySelector('.PageContent.form-content-with-pdf')
    if (!anchor || !anchor.parentNode) return false

    var existing = document.getElementById('lux-duplicate-invoice-warning')
    if (existing) existing.remove()

    var box = document.createElement('div')
    box.id = 'lux-duplicate-invoice-warning'
    box.setAttribute('role', 'alert')
    box.style.cssText = [
      'box-sizing:border-box',
      'max-width:min(544px,100%)',
      'margin:22px auto 20px auto',
      'padding:14px 16px',
      'background:#fffbe6',
      'border:1px solid #ffe58f',
      'border-radius:4px',
      'font-size:14px',
      'line-height:1.5',
      'color:rgba(0,0,0,0.85)',
      'overflow-wrap:break-word',
    ].join(';')

    var titleEl = document.createElement('div')
    titleEl.style.fontWeight = '600'
    titleEl.style.marginBottom = '8px'
    titleEl.textContent = 'Hinweis: Doppelte Rechnungsnummer'
    box.appendChild(titleEl)

    var p = document.createElement('div')
    p.style.marginBottom = '10px'
    p.textContent = propertyLabel
      ? 'Es existiert bereits mindestens eine weitere Rechnung mit der Nummer «' +
        invoiceNumber +
        '» für dasselbe Objekt («' +
        propertyLabel +
        '»). Bitte die folgenden Vorgänge prüfen:'
      : 'Es existiert bereits mindestens eine weitere Rechnung mit der Nummer «' +
        invoiceNumber +
        '» für dasselbe Objekt. Bitte die folgenden Vorgänge prüfen:'
    box.appendChild(p)

    var list = document.createElement('ul')
    list.style.margin = '0'
    list.style.paddingLeft = '20px'
    othersRows.forEach(function (r) {
      var hr = r.invoiceHrId || r.id
      if (!hr) return
      var li = document.createElement('li')
      li.style.marginTop = '4px'
      var a = document.createElement('a')
      a.href = luxInvoiceEditUrlForHrId(hr)
      a.target = '_blank'
      a.rel = 'noopener noreferrer'
      a.style.color = '#096dd9'
      a.textContent = String(hr)
      if (r.propertyName) {
        a.title = String(r.propertyName)
      }
      li.appendChild(a)
      if (r.propertyName) {
        li.appendChild(document.createTextNode(' — ' + String(r.propertyName)))
      }
      list.appendChild(li)
    })
    box.appendChild(list)

    anchor.parentNode.insertBefore(box, anchor)
    return true
  }

  if (tryMount()) return
  var tries = 0
  var timer = setInterval(function () {
    tries += 1
    if (tryMount() || tries >= 50) {
      clearInterval(timer)
    }
  }, 200)
}

/**
 * Remove the duplicate-invoice warning if present. Needed when SPA navigation reuses
 * the same shell: a banner from a previous invoice must not stay on screen.
 */
function removeLuxDuplicateInvoiceNumberBanner() {
  var el = document.getElementById('lux-duplicate-invoice-warning')
  if (el) el.remove()
}

/**
 * On invoice edit (or payments invoice) load: if Impower already has internal id + property,
 * detect another invoice with the same invoice number on the same property (API: property + invoiceNumber) and show a banner.
 */
function runDuplicateInvoiceAlertOnEditLoad() {
  const invoiceHrIdFromUrl = (window.location.pathname.split('/').pop() || '').trim()
  if (!invoiceHrIdFromUrl) return

  const dedupeKey = '_luxDuplicateInvoiceLoadAlert_' + invoiceHrIdFromUrl
  if (window[dedupeKey]) return
  window[dedupeKey] = 'running'

  ;(async function () {
    try {
      // Clear stale banner if the DOM shell was reused (SPA) before this run re-adds it when needed.
      removeLuxDuplicateInvoiceNumberBanner()

      const authRaw = localStorage.getItem('auth')
      if (!authRaw) return
      const token = JSON.parse(authRaw).token
      if (!token) return

      const detailUrl =
        baseApiUrl +
        '/services/pmp-accounting/api/v1/invoices/' +
        encodeURIComponent(invoiceHrIdFromUrl)
      const detailRes = await fetch(detailUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        credentials: 'include',
      })
      if (!detailRes.ok) return

      const inv = await detailRes.json()
      const internalId = inv.id != null ? inv.id : inv.invoiceId
      const propertyId = inv.propertyId
      if (internalId == null || propertyId == null) return

      const invoiceNumber = inv.invoiceNumber
      if (!invoiceNumber || String(invoiceNumber).trim() === '') return

      const propertyLabel =
        inv.propertyName != null ? String(inv.propertyName).trim() : ''

      // encodeURIComponent uses %20 for spaces; URLSearchParams uses + which Impower rejects here
      var listQueryParts = [
        'invoiceNumber=' + encodeURIComponent(String(invoiceNumber).trim()),
        'page=' + encodeURIComponent('0'),
        'size=' + encodeURIComponent('100'),
        'sort=' + encodeURIComponent('invoiceHrId'),
        'order=' + encodeURIComponent('DESC'),
        '_luxListT=' + encodeURIComponent(String(Date.now())),
      ]
      if (propertyLabel) {
        listQueryParts.push(
          'property=' + encodeURIComponent(propertyLabel)
        )
      }
      var listUrl =
        baseApiUrl +
        '/services/pmp-accounting/api/v1/invoices?' +
        listQueryParts.join('&')

      const listRes = await fetch(listUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        credentials: 'include',
      })
      if (!listRes.ok) return

      const listData = await listRes.json()
      const rows = Array.isArray(listData.content) ? listData.content : []
      const norm = function (s) {
        return String(s).trim().toLowerCase()
      }
      const invNumNorm = norm(invoiceNumber)
      var samePropertyId = function (a, b) {
        if (a == null || b == null) return false
        return String(a) === String(b)
      }
      var sameNumberRows = rows.filter(function (row) {
        if (!row) return false
        if (!samePropertyId(row.propertyId, propertyId)) return false
        if (!row.invoiceNumber || norm(row.invoiceNumber) !== invNumNorm)
          return false
        return true
      })
      var currentHr = inv.invoiceHrId != null ? String(inv.invoiceHrId) : invoiceHrIdFromUrl
      var others = sameNumberRows.filter(function (row) {
        var sameAsCurrent =
          (row.invoiceHrId != null && String(row.invoiceHrId) === currentHr) ||
          (row.id != null &&
            internalId != null &&
            String(row.id) === String(internalId))
        return !sameAsCurrent
      })

      if (others.length > 0) {
        mountLuxDuplicateInvoiceNumberBanner(
          invoiceNumber,
          others,
          propertyLabel
        )
      }
    } catch (e) {
      console.error('Lux duplicate invoice check on load failed', e)
    } finally {
      delete window[dedupeKey]
    }
  })()
}

function setupDuplicateInvoiceCheck() {
  const checkFormSectionInterval = setInterval(() => {
    const formSection = document.querySelector('div.FormSection#InvoiceProcessing');
    
    if (formSection) {
      clearInterval(checkFormSectionInterval);
      
      const saveButton = formSection.querySelector('button.ant-btn.section-submit');
      const propertySelectContainer = formSection.querySelector('.ant-select-in-form-item');
      const invoiceNumberInput = formSection.querySelector('input.ant-input[placeholder="Bitte ausfüllen..."]');
      
      if (saveButton && propertySelectContainer && invoiceNumberInput) {
        
        // the wrapper intercepts clicks to the save button
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-block';
        
        saveButton.parentNode.insertBefore(wrapper, saveButton);
        wrapper.appendChild(saveButton);
        
        let isProcessingClick = false;
        
        wrapper.addEventListener('click', async function(event) {
          if (isProcessingClick) {
            return;
          }
          
          event.preventDefault();
          event.stopPropagation();
          isProcessingClick = true;
          
          let propertyName = '';
          const propertySelectedItem = propertySelectContainer.querySelector('.ant-select-selection-item');
          
          if (propertySelectedItem) {
            propertyName = propertySelectedItem.textContent.trim();
          }
          
          const invoiceNumber = invoiceNumberInput.value.trim();
          
          if (propertyName && invoiceNumber) {
            const isDuplicate = await checkDuplicateInvoice(propertyName, invoiceNumber);
            
            if (isDuplicate) {
              console.log("Duplicate invoice detected");
              
              showToast(
                `WARNUNG: Eine Rechnung mit der Nummer "${invoiceNumber}" existiert bereits für das Objekt "${propertyName}".`,
                'warning',
                5000
              );
              
              invoiceNumberInput.style.border = '2px solid rgb(250, 43, 20)';
              setTimeout(() => {
                invoiceNumberInput.style.border = ''; 
              }, 5000);
              
              isProcessingClick = false;
            } else {
              setTimeout(() => {
                saveButton.dispatchEvent(new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window
                }));
                setTimeout(() => { isProcessingClick = false; }, 0);
              }, 0);
            }
          } else {
            setTimeout(() => {
              saveButton.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
              }));
              setTimeout(() => { isProcessingClick = false; }, 0);
            }, 0);
          }
        }, true);
      } else {
        console.log("Save button not found, skipping duplicate invoice check setup");
      }
    }
  }, 500);
}

const checkDuplicateInvoice = async (propertyName, invoiceNumber) => {
  if (!propertyName || !invoiceNumber) {
    return false;
  }
  
  const apiUrl = `${baseApiUrl}/api/impowerX/invoices?propertyName=${encodeURIComponent(propertyName)}`;
  
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${JSON.parse(localStorage.auth).token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      console.error('API response error:', response.status);
      return false;
    }
    
    const data = await response.json();
    const invoices = data?.content?.content || [];
    
    if (Array.isArray(invoices)) {
      const isDuplicate = invoices.some(invoice => 
        invoice.invoiceNumber && invoice.invoiceNumber.toLowerCase() === invoiceNumber.toLowerCase()
      );
      
      return isDuplicate;
    }
    
    return false;
  } catch (error) {
    console.error('Error checking for duplicate invoice:', error);
    return false;
  }
};
